import { FormSelectYesNo,  FormInputText, DateSelector, FormTextArea } from '../formelements'

export const ContacteEmergencia = (props) => {

    return (<div className={'col ' + props.col}>
      <div className="t-Form-labelContainer">
        <label id="contacteEmergenciaNom" className="t-Form-label">{props.label}</label>
      </div>
  
      <FormInputText id="contacteEmergenciaNom" name="contacteEmergenciaNom" label="Nom i cognoms" col="col-12" value={props.values.contacteEmergenciaNom} obligatori={props.obligatori} size="30" maxLength="50" onChange={props.onChanges.nom} error={props.errors.contacteEmergenciaNom} />
  
  
  <div className={ 'col col-12'}>
        <div id={props.id + '_CONTAINER'} className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs">
  
        <div className="t-Form-labelContainer">
          <label  className="t-Form-label">Relació amb l'alumne { props.obligatori && (<span className="t-Form-required"> <span className="a-Icon">*</span> </span>)}</label>
        </div>
  
      <div className="t-Form-inputContainer">
        <div className="t-Form-itemWrapper">
  
  
          <select id="contacteEmergenciaRelacio" defaultValue="DNI" name="contacteEmergenciaRelacio" className="selectlist" size="1" onChange={(e) => props.onChanges.relacio(e.target.value)} required={props.obligatori}>
            <option value=""></option>
            <option value="Pare">Pare</option>
            <option value="Mare">Mare</option>
            <option value="Parella">Parella</option>
            <option value="Tutor centre">Tutor centre</option>
            <option value="Altres">Altres</option>
          </select>
        </div>
        <span id="contacteEmergencia_ERROR" className="a-Form-error">{props.errors.contacteEmergenciaRelacio}</span>
      </div>
        </div>
  </div>
  
      <FormInputText id="contacteEmergenciaTelefon" name="contacteEmergenciaTelefon" label="Telèfon" col="col-12" value={props.values.contacteEmergenciaTelefon} obligatori={props.obligatori} size="30" maxLength="50" onChange={props.onChanges.telefon} error={props.errors.contacteEmergenciaTelefon} />
  
    </div>)
  }

